<template>
  <div class="animated fadeIn">
    <loader :show="enviando"/>
    <b-card>
        <h4 slot="header" class="card-title mb-0">{{nombre}}</h4>
        <b-row>
            <b-col sm="12" md="6"
                v-for="(item, index) in delegaciones" :key="index">
                <b-card>
                    <h6 slot="header" class="card-title mb-0">{{item.nombre}}</h6>
                    <b-list-group>
                        <b-list-group-item v-for="(obra, index2) in item.obras" :key="index2">
                            <div class="d-flex w-100 justify-content-between">
                                <h5 >{{obra.titulo}}</h5>
                                <small v-if="!activo" class="text-muted">{{getPorcentaje(obra._id)}}</small>
                            </div>
                            <small class="text-muted">{{obra.subtitulo}}</small>
                        </b-list-group-item>
                    </b-list-group>
                </b-card>
            </b-col>
            <b-col v-if="activo && puedeAgregarVoto">
                <b-button variant="primary" @click="agregarVoto()">
                    Agregar voto
                </b-button>
            </b-col>
        </b-row> 
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'
import Loader from '../../Loader'
import { mapGetters } from "vuex";
import moment from 'moment'
moment.locale('es');

export default {
  components: {
   Loader
  },
  computed: {
        ...mapGetters([
          "httpURL",
          "sessionToken",
          "permisos",
          "role",
          "tableProps"
        ]),
        puedeAgregarVoto(){
            if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 209) >= 0 )
                return true;
            else
                return false;
        },
    },
  data: function () {
    return {
      enviando: false,
      idEncuesta: null,
      nombre: 'Presupuesto participativo',
      activo: false,
      delegaciones: [],
      obras: []
    }
  },
  created(){
    this.enviandoStart();
    this.idEncuesta = this.$route.params.id;
    axios.get(this.httpURL+'/encuestas/presupuesto/'+this.idEncuesta,
        {headers:{token:this.sessionToken}})
        .then(res => {
            // console.log(res.data);
            this.nombre = res.data.presupuesto.nombre;
            this.activo = res.data.presupuesto.activo;
            this.delegaciones = res.data.presupuesto.delegaciones;
            this.obras = res.data.obras;
            this.enviandoStop();
          })
        .catch(error => {
          //console.log(error);
            this.enviandoStop();
            if(error.res){
                this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.res.data.mensaje });
            }else if( error.request){
                this.$notify({ group: 'foo', type:"error", duration:1500, speed: 1000,
                        text: 'No se pudo establecer una conexión al servidor.' });
            }
        });
  },
  methods: {
    enviandoStart(){
        this.enviando = true;
    },
    enviandoStop(){
        this.enviando = false;
    },
    getPorcentaje(idObra){
      let totalVotos = 0;
      this.obras.forEach(element => {
        totalVotos += element.votos;
      });
      let obra = this.obras.find(x=>x._id == idObra);
      let porcentaje = Math.round(obra.votos*100/totalVotos);
      // return `${obra.votos}/${totalVotos} (${porcentaje}%)`;
      return `${obra.votos} (${porcentaje}%)`;
    },
    agregarVoto(){
      this.$router.push('/encuestas/presupuesto/agregarVoto/'+this.idEncuesta)
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
